'use client'
import React from 'react'
import Image from "next/image"
import { useTranslations } from 'next-intl'
import { useRTLAwareStyle } from '@/util/rtl'
import { StaticImageData } from 'next/image'
import { motion } from 'framer-motion'

interface HeaderSection {
  category: string;
  imageSrc: string | StaticImageData;
}

export default function CategoryHeaderSection({ category, imageSrc }: HeaderSection) {
  const t = useTranslations('categories')
  const rtlAwareTextAlign = useRTLAwareStyle('text-left', 'text-right')
  const rtlAwarePadding = useRTLAwareStyle('pl-6 md:pl-12 lg:pl-16', 'pr-6 md:pr-12 lg:pr-16')
  const letterSpacing = useRTLAwareStyle('tracking-wider', '')
  const rtlAwareText = useRTLAwareStyle('text-left', 'text-right')

  return (
    <section className="w-full bg-gradient-to-b from-[#f0ede7] to-white">
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row items-center">
          <motion.div 
            className="w-full md:w-1/2 mb-8 md:mb-0"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className={`text-3xl text-center md:${rtlAwareText} md:text-4xl lg:text-5xl font-semibold ${letterSpacing} text-[#bcb398] mb-4`}>
              {t(`${category}.title`)}
            </h1>
            <p className={`text-lg text-gray-700 ${rtlAwareTextAlign} max-w-lg`}>
              {t(`${category}.desc`)}
            </p>
          </motion.div>
          <motion.div 
            className="w-full md:w-1/2"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="relative h-[300px] md:h-[400px] lg:h-[500px] rounded-lg overflow-hidden shadow-xl">
              <Image
                src={imageSrc}
                alt={t(`${category}.alt`)}
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                className="object-cover"
                priority
              />
              <div className="absolute inset-0 border-4 border-[#bcb398] opacity-50 rounded-lg"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}